import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getActivityLookups } from '../api/activityApi'

/** Yeni Etkinlik formu + filtreler için kod listeleri (dil değişince ad'lar için yeniden çeker). */
export function useActivityLookups() {
  const { i18n } = useTranslation()
  return useQuery({
    queryKey: ['activity-lookups', i18n.language],
    queryFn: getActivityLookups,
  })
}
